import { useState, useEffect } from "react";
// ★U8(cmd-po_1109): sip-stepper共通部品
import { SipStepper } from "./common/SipStepper";
// ★cmd-po_1200(T2b-1): raw Modal frame → 共通外殻 PoModalShell
import { PoModalShell } from "./common/PoModalShell";

// ui
import {
  Button,
  Typography,
  Box,
  Paper,
  MenuItem,
  IconButton,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EmailIcon from "@mui/icons-material/Email";

// QRコード生成
import { QRCodeCanvas } from "qrcode.react";

// InterFace
import { TableColumn } from "../config/dataInterface";

// API
import { getContractProduct } from "../api/contract";
import { getAddress } from "../api/address";
import {
  getPresignedPostPicture,
  postPresignedPost,
} from "../api/presignedURL";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

// 共有部品
import { LeaveGuard } from "./list/LeaveGuard";
// ★ cmd-po_1135: po-form 共通部品
import { PoField, PoLabel, PoTextField, PoSelect, PoCheckbox, PoHelper, PoSplit, PoCheckGroup, PoCheckRow, PoFileDrop, PO_FORM_MSG, isValidMail, isValidTel, isValidZip } from "./common/PoForm";

interface InputFreeTextProps {
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    phone_number: string;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "product"
        | "entry_method"
        | "site_path"
        | "contract"
        | "sms_success";
      outSiteEntry: 0 | 1;
      outsideSiteUrl: string;
      outsideServiceUrl: string;
      viewOutsideServiceUrl: 0 | 1;
      productId: number | null;
      productName: string;
      have_entry_form: number | null;
      site_path_list: string[];
      site_path: string;
      outsideMessageType: number | null;
      phone_number: string;
      customer_name: string;
      customer_company_name: string;
      servicePlanName: string;
      serviceContentNameList: string[];
      serviceCampaignPulldownName: string;
      serviceCampaignCheckboxName: string[];
      servicePaymentMethodName: string;
      serviseCustomerListID: string;
      pullDownServiceName: string;
      checkBoxServiceNames: string;
      smsMessagePatternID: number | null;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  uniqueOption: { [key: string]: string | number | string[] };
  addressOptionName: string;
}

function InputFreeText(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        fullWidth
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextHalfWidthNumber(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        fullWidth
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          const inputValue = e.target.value;
          if (!/^\d*$/.test(inputValue)) return;
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = inputValue;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        inputProps={{ inputMode: "numeric", pattern: "\\d*" }}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "" || input3 !== "") && !isValidTel(`${input1}-${input2}-${input3}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      const phone_number = input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        phone_number,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdTel1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel3"
          value={input3}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextFormTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "" || input3 !== "") && !isValidTel(`${input1}-${input2}-${input3}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdTel1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel3"
          value={input3}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      const customer_name = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customer_name,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdName1"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
        />
        <PoTextField
          id="textFieldIdName2"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
        />
      </PoSplit>
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextCompanyName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        fullWidth
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          const customer_company_name = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
            customer_company_name,
          }));
        }}
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextZipCode(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "") && !isValidZip(`${input1}-${input2}`);
  useEffect(() => {
    async function getAddressText(zipCode: string) {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = zipCode;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));

      const address = await getAddress(zipCode);
      customerInfo[addressOptionName] = address;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const zipCode = input1 + "-" + input2;
      if (input1.length === 3 && input2.length === 4) {
        getAddressText(zipCode);
      } else {
        let customerInfo = addData.customerInfo;
        customerInfo[uniqueOption.option_name as string] = zipCode;
        setAddData((addData) => ({
          ...addData,
          customerInfo,
        }));
      }
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdZipCode1"
          value={input1}
          inputProps={{ maxLength: 3 }}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 3) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdZipCode2"
          value={input2}
          inputProps={{ maxLength: 4 }}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 4) {
              setInput2(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextSpace(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdSpace1"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
        />
        <PoTextField
          id="textFieldIdSpace2"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
        />
      </PoSplit>
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextMailAddress(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "") && !isValidMail(`${input1}@${input2}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("@");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + "@" + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdmm1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => setInput1(e.target.value)}
        />
        <Box sx={{ flex: "0 0 auto" }}>@</Box>
        <PoTextField
          id="textFieldIdmm2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => setInput2(e.target.value)}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

interface ContractAddModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  tableColumn: TableColumn;
  postAddData: (customerInfo: { [key: string]: string | string[] }) => void;
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    phone_number: string;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "product"
        | "entry_method"
        | "site_path"
        | "contract"
        | "sms_success";
      outSiteEntry: 0 | 1;
      outsideSiteUrl: string;
      outsideServiceUrl: string;
      viewOutsideServiceUrl: 0 | 1;
      productId: number | null;
      productName: string;
      have_entry_form: number | null;
      site_path_list: string[];
      site_path: string;
      outsideMessageType: number | null;
      phone_number: string;
      customer_name: string;
      customer_company_name: string;
      servicePlanName: string;
      serviceContentNameList: string[];
      serviceCampaignPulldownName: string;
      serviceCampaignCheckboxName: string[];
      servicePaymentMethodName: string;
      serviseCustomerListID: string;
      pullDownServiceName: string;
      checkBoxServiceNames: string;
      smsMessagePatternID: number | null;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  contractProductList: {
    id: number;
    product_name: string;
    have_entry_form: number;
    site_path_list: string[];
  }[];
  firstYear: number;
  thisYear: number;
  selectServisePlanList: { service_name: string }[];
  setSelectServisePlanList: (value: { service_name: string }[]) => void;
  selectServiseContentList: { service_name: string }[];
  setSelectServiseContentList: (value: { service_name: string }[]) => void;
  selectServiseCampaignPulldownList: { service_name: string }[];
  setSelectServiseCampaignPulldownList: (
    value: { service_name: string }[],
  ) => void;
  selectServiseCampaignCheckboxList: { service_name: string }[];
  setSelectServiseCampaignCheckboxList: (
    value: { service_name: string }[],
  ) => void;
  selectServisePaymentList: { payment_method: string }[];
  setSelectServisePaymentList: (value: { payment_method: string }[]) => void;
  uniqueOptinList: { [key: string]: string | number | string[] }[];
  setUniqueOptinList: (
    value: { [key: string]: string | number | string[] }[],
  ) => void;
  addressOptionName: string;
  setAddressOptionName: (name: string) => void;
  postPictures: {
    [key: string]: File;
  };
  setPostPicture: (value: { [key: string]: File }) => void;
  setOnDataAddModalResult: (value: string) => void;
  accountCollaborateCompanySaleList?: {
    sale_company_id: number;
    sale_company_name: string;
    id: number;
    account_name: string;
  }[];
  accountColumn?: string;
  getFormFunction?: () => void;
}

export function ContractAddModal(props: ContractAddModalProps) {
  const {
    onModal,
    swCloseModal,
    tableColumn,
    postAddData,
    addData,
    setAddData,
    contractProductList,
    firstYear,
    thisYear,
    selectServisePlanList,
    setSelectServisePlanList,
    selectServiseContentList,
    setSelectServiseContentList,
    selectServiseCampaignPulldownList,
    setSelectServiseCampaignPulldownList,
    selectServiseCampaignCheckboxList,
    setSelectServiseCampaignCheckboxList,
    selectServisePaymentList,
    setSelectServisePaymentList,
    uniqueOptinList,
    setUniqueOptinList,
    addressOptionName,
    setAddressOptionName,
    postPictures,
    setPostPicture,
    setOnDataAddModalResult,
    accountCollaborateCompanySaleList,
    accountColumn,
    getFormFunction,
  } = props;
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const [leaveGuardOpen, setLeaveGuardOpen] = useState(false);
  const [postPicturesError, setPostPicturesError] = useState<{[key: string]: string}>({});

  const hasStep1 = getFormFunction !== undefined;

  const acctName = (() => {
    if (addData.changeAccount === 1 && addData.changeAccountID !== null) {
      return (accountCollaborateCompanySaleList ?? []).find(
        (x) => x.id === addData.changeAccountID
      )?.account_name ?? "";
    }
    return loginUser?.username ?? "";
  })();

  // ★cmd-po_1200: frame sx(旧 const style=fixed/680px/92vh/radius/shadow)は PoModalShell width="w680"(PO_MODAL_SX_W680)へ移譲。
  //   PC幅680px・maxHeight92vh・radius/shadow(var同一)は保全。position fixed→absolute・zIndex310除去は共通外殻へ吸収(MUI Modal root が stacking/中央枠を担う=PC視覚不変)。

  // 商材一覧検索用
  const [inputSerchProductName, setInputSerchProductName] = useState("");
  const [serchProductList, setSerchProductList] = useState<
    {
      id: number;
      product_name: string;
      have_entry_form: number;
      site_path_list: string[];
    }[]
  >([]);
  useEffect(() => {
    if (inputSerchProductName === "") {
      const serchProductList = contractProductList.filter(
        (product) =>
          product.have_entry_form === 1 || product.site_path_list.length > 0,
      );
      setSerchProductList(serchProductList);
    } else {
      const serchProductList = contractProductList.filter(
        (product) =>
          (product.have_entry_form === 1 ||
            product.site_path_list.length > 0) &&
          product.product_name.includes(inputSerchProductName),
      );
      setSerchProductList(serchProductList);
    }
  }, [contractProductList, inputSerchProductName]);

  // 外部ET用の変数
  const [outSidePullDownServiceNameList, setOutSidePullDownServiceNameList] =
    useState<{ service_name: string }[]>([]);
  const [outSideCheckBoxServiceNameList, setOutSideCheckBoxServiceNameList] =
    useState<{ service_name: string }[]>([]);
  const [smsMessagePatterns, setSmsMessagePatterns] = useState<
    {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_body: string;
    }[]
  >([]);
  const [mailMessagePatterns, setMailMessagePatterns] = useState<
    {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_title: string;
      outside_sms_body: string;
    }[]
  >([]);

  const [useMailAddressFlg, setUseMailAddressFlg] = useState(false);

  async function getProductInfo(
    productId: number,
    productName: string,
    outSiteEntry: 0 | 1,
    site_path: string,
  ) {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    const {
      service_plan_data,
      service_content_data,
      service_campaign_pulldown_data,
      service_campaign_checkbox_data,
      service_payment_data,
      option_data,
      outside_pull_down_service,
      outside_check_box_service,
      outside_option_data,
      outside_sms_patterns,
      outside_mail_patterns,
    } = await getContractProduct(
      productId,
      outSiteEntry,
      site_path,
      addData.changeAccount,
      addData.changeAccountID,
    );
    if (outSiteEntry === 0) {
      // 内部エントリー
      if (service_plan_data.length === 0) {
        swCloseModal();
        setOnDataAddModalResult(
          "エントリー可能なプランが定義されていません。管理者に問い合わせてください。",
        );
      } else {
        setSelectServisePlanList(service_plan_data);
        setSelectServiseContentList(service_content_data);
        if (service_campaign_pulldown_data.length > 0) {
          setSelectServiseCampaignPulldownList([
            { service_name: "" },
            ...service_campaign_pulldown_data,
          ]);
        } else {
          setSelectServiseCampaignPulldownList(service_campaign_pulldown_data);
        }
        setSelectServiseCampaignCheckboxList(service_campaign_checkbox_data);
        setSelectServisePaymentList(service_payment_data);
        setUniqueOptinList(option_data);
        if (option_data.length > 0) {
          const customerInfo: {
            [key: string]: string | string[];
          } = option_data.reduce<{ [key: string]: string | string[] }>(
            (column, option) => {
              let option_value: string | string[] = "";
              if (option.option_type === 0) {
                option_value = option.option_default_value as string;
                return {
                  ...column,
                  [option.option_name as string]: option_value,
                };
              } else if (option.option_type === 1 || option.option_type === 4) {
                return {
                  ...column,
                  [option.option_name as string]: "",
                };
              } else if (option.option_type === 3) {
                return {
                  ...column,
                  [option.option_name as string]: "",
                };
              } else {
                return {
                  ...column,
                  [option.option_name as string]: [],
                };
              }
            },
            {},
          );
          let addressOptionName = "";
          option_data.map((uniqueOptin) => {
            if (uniqueOptin.address_flg) {
              addressOptionName = uniqueOptin.option_name as string;
            }
          });
          setAddressOptionName(addressOptionName);
          setAddData((addData) => ({
            ...addData,
            customerInfo,
            addStatus: "contract",
            productId,
            productName,
            outSiteEntry,
          }));
        } else {
          swCloseModal();
          setOnDataAddModalResult(
            "エントリーフォームが定義されていません。管理者に問い合わせてください。",
          );
        }
      }
    } else if (outSiteEntry === 1) {
      // 外部エントリー
      setOutSidePullDownServiceNameList(outside_pull_down_service);
      setOutSideCheckBoxServiceNameList(outside_check_box_service);
      setSmsMessagePatterns(outside_sms_patterns);
      setMailMessagePatterns(outside_mail_patterns);
      if (outside_option_data.length > 0) {
        const customerInfo: {
          [key: string]: string | string[];
        } = outside_option_data.reduce<{ [key: string]: string | string[] }>(
          (column, option) => {
            let option_value: string | string[] = "";
            if (option.option_type === 0) {
              option_value = option.option_default_value as string;
              return {
                ...column,
                [option.option_name as string]: option_value,
              };
            } else if (option.option_type === 1 || option.option_type === 4) {
              return {
                ...column,
                [option.option_name as string]: "",
              };
            } else if (option.option_type === 3) {
              return {
                ...column,
                [option.option_name as string]: "",
              };
            } else {
              return {
                ...column,
                [option.option_name as string]: [],
              };
            }
          },
          {},
        );
        let addressOptionName = "";
        let mail_address_flg_use = false;
        outside_option_data.map((uniqueOptin) => {
          if (uniqueOptin.address_flg) {
            addressOptionName = uniqueOptin.option_name as string;
          }
          if (uniqueOptin.mail_address_flg_use) {
            mail_address_flg_use = true;
          }
        });
        setUseMailAddressFlg(mail_address_flg_use);
        setUniqueOptinList(outside_option_data);
        setAddressOptionName(addressOptionName);
        setAddData((addData) => ({
          ...addData,
          customerInfo,
          addStatus: "contract",
          productId,
          productName,
          site_path,
          outSiteEntry,
        }));
      } else {
        swCloseModal();
        setOnDataAddModalResult(
          "外部ETフォームが定義されていません。管理者に問い合わせてください。",
        );
      }
    }
  }

  const [onPostBottun, setOnPostBottun] = useState(false);
  useEffect(() => {
    if (addData.addStatus !== null && addData.addStatus !== "loading") {
      let onPostBottun = true;
      // 内部エントリーの時のみ依存関係確認
      if (addData.outSiteEntry == 0) {
        uniqueOptinList.map((uniqueOptin) => {
          const service_plan_names = uniqueOptin.service_plan_names as string[];
          const service_content_names =
            uniqueOptin.service_content_names as string[];
          const depend_option_name = uniqueOptin.depend_option_name as string;
          const depend_select_names =
            uniqueOptin.depend_select_names as string[];
          const depend_option_value = addData.customerInfo[depend_option_name];
          if (
            uniqueOptin.required_optional === 1 &&
            (service_plan_names.length === 0 ||
              service_plan_names.includes(addData.servicePlanName)) &&
            (service_content_names.length === 0 ||
              service_content_names.some((item) =>
                addData.serviceContentNameList.includes(item),
              )) &&
            (depend_option_name === "他質問に依存しない" ||
              (typeof depend_option_value === "string" &&
                depend_select_names.includes(depend_option_value as string)) ||
              (typeof depend_option_value === "object" &&
                depend_select_names.some((item) =>
                  depend_option_value.includes(item),
                )))
          ) {
            if (
              uniqueOptin.option_type === 0 ||
              uniqueOptin.option_type === 1 ||
              uniqueOptin.option_type === 3
            ) {
              const customerInfoValue = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string;
              if (
                customerInfoValue === undefined ||
                customerInfoValue === "" ||
                customerInfoValue === " " ||
                customerInfoValue === "--"
              ) {
                onPostBottun = false;
              }
            } else if (uniqueOptin.option_type === 2) {
              const customerInfoValue = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string[];
              if (customerInfoValue.length === 0) {
                onPostBottun = false;
              }
            } else if (uniqueOptin.option_type === 4) {
              if (!postPictures[uniqueOptin.option_name as string]) {
                onPostBottun = false;
              }
            }
          }
        });

        if (addData.servicePlanName === "") {
          onPostBottun = false;
        }
        if (
          selectServisePaymentList.length > 0 &&
          addData.servicePaymentMethodName === ""
        ) {
          onPostBottun = false;
        }
      }

      // 外部ETフォーム
      if (addData.outSiteEntry == 1) {
        // SMS送信情報確認
        if (addData.outsideMessageType === null) {
          onPostBottun = false;
        }
        if (
          (addData.outsideMessageType === 0 ||
            addData.outsideMessageType === 1) &&
          addData.smsMessagePatternID === null
        ) {
          onPostBottun = false;
        }

        // SMS送信の場合は顧客電話番号の確認
        if (addData.outsideMessageType === 0) {
          if (addData.phone_number === "--") {
            onPostBottun = false;
          }
        }

        // メール送信の場合はメールアドレスの確認
        if (addData.outsideMessageType === 1) {
          let mail_address = "@";
          // そもそも質問にメールアドレスが定義されていない場合
          if (useMailAddressFlg === false) {
            mail_address = addData.customerInfo["メールアドレス"] as string;
          }
          uniqueOptinList.map((uniqueOptin) => {
            if (uniqueOptin.mail_address_flg === 1) {
              mail_address = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string;
            }
          });
          if (mail_address === "@") {
            onPostBottun = false;
          }
        }
      }

      setOnPostBottun(onPostBottun);
    }
  }, [addData, postPictures]);

  // 契約登録前に画像データ格納
  async function postAddContractData() {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    let customerInfo = { ...addData.customerInfo };
    const results = await Promise.all(
      uniqueOptinList.map(async (uniqueOption) => {
        if (
          uniqueOption.option_type === 4 &&
          postPictures[uniqueOption.option_name as string]
        ) {
          const postPicture = postPictures[uniqueOption.option_name as string];
          // 著名付きURL(post用)を作成
          const fileName = postPicture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);

          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", postPicture);
          // ファイルをS3にアップロード（S3受理確認）
          const r = await postPresignedPost(presigned_object.url, formData);
          if (r === "seccess") {
            customerInfo[uniqueOption.option_name as string] = destination_key;
          }
          return r;
        }
        return "seccess";
      }),
    );
    if (results.some((r) => r !== "seccess")) {
      const errMap: {[key: string]: string} = {};
      uniqueOptinList.forEach((opt, i) => {
        if (results[i] !== "seccess") {
          errMap[opt.option_name as string] = "画像のアップロードに失敗しました。もう一度お試しください。";
        }
      });
      setPostPicturesError(errMap);
      setAddData((addData) => ({ ...addData, addStatus: "contract" }));
      setOnDataAddModalResult("画像のアップロードに失敗しました。もう一度お試しください");
      return;
    }
    await postAddData(customerInfo);
  }

  // ★cmd-po_1200(T2b-1): footer は addStatus 別に raw Button を verbatim（PoButton化せず po-btn 機能class維持）で PoModalShell footer prop へ移設。
  //   旧「modal Box直下 pin」5分岐（product/entry_method/site_path/sms_success/contract）を集約。change_account=footer無(undefined)。
  const contractAddFooter =
    addData.addStatus === "product" ? (
      <Button
        data-testid="contract-add-product-close"
        variant="outlined"
        className="po-btn po-btn-secondary"
        sx={{
          textTransform: "none",
          minWidth: "unset",
          boxShadow: "none",
          backgroundColor: "var(--color-white, #ffffff)",
          color: "var(--color-ai, #1e3a5f)",
          border: "1px solid var(--color-border, #e5e5e0)",
          padding: "0 var(--sp-4, 16px)",
          height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
          "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
        }}
        onClick={() => {
          if (hasStep1) {
            setLeaveGuardOpen(true);
          } else {
            swCloseModal();
          }
        }}
      >
        <Box>戻る</Box>
      </Button>
    ) : addData.addStatus === "entry_method" ? (
      <Button
        data-testid="contract-add-entry-method-back"
        variant="outlined"
        className="po-btn po-btn-secondary"
        sx={{
          textTransform: "none",
          minWidth: "unset",
          boxShadow: "none",
          backgroundColor: "var(--color-white, #ffffff)",
          color: "var(--color-ai, #1e3a5f)",
          border: "1px solid var(--color-border, #e5e5e0)",
          padding: "0 var(--sp-4, 16px)",
          height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
          "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
        }}
        onClick={() => {
          setAddData((addData) => ({
            ...addData,
            addStatus: "product",
          }));
        }}
      >
        <Box>戻る</Box>
      </Button>
    ) : addData.addStatus === "site_path" ? (
      <Button
        variant="outlined"
        data-testid="contract-add-site-path-back"
        className="po-btn po-btn-secondary"
        sx={{
          textTransform: "none",
          minWidth: "unset",
          boxShadow: "none",
          backgroundColor: "var(--color-white, #ffffff)",
          color: "var(--color-ai, #1e3a5f)",
          border: "1px solid var(--color-border, #e5e5e0)",
          padding: "0 var(--sp-4, 16px)",
          height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
          "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
        }}
        onClick={() => {
          setAddData((addData) => ({
            ...addData,
            addStatus: "entry_method",
          }));
        }}
      >
        <Box>戻る</Box>
      </Button>
    ) : addData.addStatus === "sms_success" ? (
      <>
        <Button
          variant="outlined"
          data-testid="contract-add-success-back"
          className="po-btn po-btn-secondary"
          sx={{
            textTransform: "none",
            minWidth: "unset",
            boxShadow: "none",
            backgroundColor: "var(--color-white, #ffffff)",
            color: "var(--color-ai, #1e3a5f)",
            border: "1px solid var(--color-border, #e5e5e0)",
            padding: "0 var(--sp-4, 16px)",
            height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
            "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
          }}
          onClick={() => {
            setAddData((addData) => ({
              ...addData,
              addStatus: "contract",
            }));
          }}
        >
          <Box>入力に戻る</Box>
        </Button>
        <Button
          variant="contained"
          data-testid="contract-add-success-close"
          className="po-btn po-btn-primary"
          sx={{
            textTransform: "none",
            minWidth: "unset",
            boxShadow: "none",
            backgroundColor: "var(--color-ai, #1e3a5f)",
            color: "var(--color-white, #ffffff)",
            border: "1px solid transparent",
            padding: "0 var(--sp-4, 16px)",
            height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
            "&:hover": { boxShadow: "none", backgroundColor: "var(--color-ai-light, #2a5a8f)" },
            "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
          }}
          onClick={swCloseModal}
        >
          <Box>閉じる</Box>
        </Button>
      </>
    ) : addData.addStatus === "contract" ? (
      <>
        <Button
          variant="outlined"
          data-testid="contract-add-contract-back"
          className="po-btn po-btn-secondary"
          sx={{
            textTransform: "none",
            minWidth: "unset",
            boxShadow: "none",
            backgroundColor: "var(--color-white, #ffffff)",
            color: "var(--color-ai, #1e3a5f)",
            border: "1px solid var(--color-border, #e5e5e0)",
            padding: "0 var(--sp-4, 16px)",
            height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
            "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
          }}
          onClick={() => {
            setAddData((addData) => ({
              ...addData,
              addStatus: "product",
              productId: null,
              productName: "",
              have_entry_form: null,
              servicePlanName: "",
              serviceContentNameList: [],
              serviceCampaignPulldownName: "",
              serviceCampaignCheckboxName: [],
              servicePaymentMethodName: "",
              serviseCustomerListID: "",
              pullDownServiceName: "",
              checkBoxServiceNames: "",
              smsMessagePatternID: null,
              customerInfo: {},
            }));
            setSelectServisePlanList([]);
            setSelectServiseContentList([]);
            setSelectServiseCampaignPulldownList([]);
            setSelectServiseCampaignCheckboxList([]);
            setSelectServisePaymentList([]);
            setUniqueOptinList([]);
            setAddressOptionName("");
            setOutSidePullDownServiceNameList([]);
            setOutSideCheckBoxServiceNameList([]);
            setSmsMessagePatterns([]);
            setMailMessagePatterns([]);
            setUseMailAddressFlg(false);
          }}
        >
          <Box>戻る</Box>
        </Button>
        <Button
          data-testid="contract-add-submit"
          disabled={!onPostBottun}
          variant="contained"
          className="po-btn po-btn-primary"
          sx={{
            textTransform: "none",
            minWidth: "unset",
            boxShadow: "none",
            backgroundColor: "var(--color-ai, #1e3a5f)",
            color: "var(--color-white, #ffffff)",
            border: "1px solid transparent",
            padding: "0 var(--sp-4, 16px)",
            height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
            "&:hover": { boxShadow: "none", backgroundColor: "var(--color-ai-light, #2a5a8f)" },
            "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
          }}
          onClick={postAddContractData}
        >
          <Box
            style={{
              color: !onPostBottun ? "rgb(70 70 70)" : undefined,
            }}
          >
            {addData.outSiteEntry === 0
              ? "新規登録"
              : addData.outsideMessageType === null ||
                  addData.outsideMessageType === 0
                ? "SMS送信"
                : addData.outsideMessageType === 1
                  ? "メール送信"
                  : addData.outsideMessageType === 2
                    ? "QRコード表示"
                    : "SMS送信"}
          </Box>
          {addData.outSiteEntry === 0 ? (
            <AddCircleOutlineIcon
              sx={{
                marginLeft: "6px",
                color: !onPostBottun ? "rgb(70 70 70)" : "white",
              }}
              fontSize="medium"
            />
          ) : (
            <EmailIcon
              sx={{
                marginLeft: "6px",
                color: !onPostBottun ? "rgb(70 70 70)" : "white",
              }}
              fontSize="medium"
            />
          )}
        </Button>
      </>
    ) : undefined;

  return addData.addStatus !== null && addData.addStatus !== "loading" ? (
    // cmd-po_1200(T2b-1): raw Modal → 共通外殻 PoModalShell（precedent=ProductEditModal:1163 / cmd-1199）
    // ★SipStepper=beforeBody slot(header直後・非スクロール帯=視覚位置保全) / footer=addStatus別 raw Button verbatim(po-btn機能class維持) / LeaveGuard=PoModalShell兄弟
    // ★backdrop/Escで閉じない現挙動保全（旧Modalに onClose 無配線=PoModalShell も同=差異なし）
    <>
      <PoModalShell
        open={onModal}
        title="エントリー登録"
        onClose={swCloseModal}
        width="w680"
        testidPrefix="contract-add"
        beforeBody={
          <SipStepper
            steps={hasStep1 ? ["担当アカウント", "商材選択", "情報入力"] : ["商材選択", "情報入力"]}
            activeIndex={
              hasStep1
                ? addData.addStatus === "change_account" ? 0
                  : addData.addStatus === "product" ? 1
                  : 2
                : addData.addStatus === "product" ? 0 : 1
            }
            suffix={
              hasStep1 && addData.addStatus !== "change_account" && acctName ? (
                <Box sx={{ fontSize: 11, fontWeight: 600, color: "var(--color-ai, #1e3a5f)", bgcolor: "var(--color-ai-pale, #e8eef4)", borderRadius: "999px", px: 1.25, py: 0.375, flexShrink: 0, whiteSpace: "nowrap" }}>
                  担当: {acctName}
                </Box>
              ) : undefined
            }
          />
        }
        footer={contractAddFooter}
      >
        {addData.addStatus === "product" ? (
          <>
            <PoField fieldKey="search_product_name">
              <PoLabel>商材検索（部分一致）</PoLabel>
              <PoTextField
                id="inputSerchProductName"
                data-testid="contract-add-product-search"
                fullWidth
                value={inputSerchProductName}
                onChange={async (e) => {
                  setInputSerchProductName(e.target.value);
                }}
              />
            </PoField>
          </>
        ) : null}
        {addData.addStatus === "entry_method" ? (
          <Box >エントリー方法</Box>
        ) : null}
        {addData.addStatus === "site_path" ? (
          <Box >サイトパス</Box>
        ) : null}
        {addData.addStatus === "product" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 0,
              mb: 5,
              maxHeight: !isSmartPhone ? undefined : "calc(92vh - 100px)",
              overflowY: !isSmartPhone ? undefined : "auto",
            }}
            key="ContractAddModalBoxProject"
          >
            <Paper elevation={0}>
              <Box
                key="shozai1"
                sx={{}}
              >
                <Box
                  key="shozaiClick"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                >
                  {serchProductList.map((product, i) => {
                    return (
                      <Box
                        sx={{
                          marginTop: "10px",
                          height: "40px",
                          width:
                            !isSmartPhone
                              ? "calc(50% - 5px)"
                              : "calc(100% - 10px)",
                          marginLeft:
                            !isSmartPhone && i % 2 !== 0 ? "10px" : "0",
                        }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            height: "40px",
                            width: "100%",
                            textTransform: "none",
                          }}
                          onClick={async () => {
                            const productId = product.id;
                            const productName = product.product_name;
                            const have_entry_form = product.have_entry_form;
                            const site_path_list = product.site_path_list;
                            if (site_path_list.length > 0) {
                              setAddData((addData) => ({
                                ...addData,
                                addStatus: "entry_method",
                                productId,
                                productName,
                                have_entry_form,
                                site_path_list,
                              }));
                            } else {
                              await getProductInfo(
                                productId,
                                productName,
                                0,
                                "",
                              );
                            }
                          }}
                        >
                          <Box >
                            {product.product_name}
                          </Box>
                        </Button>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Paper>
          </Typography>
        ) : addData.addStatus === "entry_method" ? (
          <Typography
            key="ContractAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: !isSmartPhone ? undefined : "calc(92vh - 30px)",
              overflowY: !isSmartPhone ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                key="contract1"
                sx={{}}
              >
                <Box
                  key="shozaiClick"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                >
                  <Box
                    sx={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        !isSmartPhone
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: "0px",
                    }}
                  >
                    <Button
                      data-testid="contract-add-entry-method-entry"
                      disabled={addData.have_entry_form === 0}
                      variant="contained"
                      sx={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                        "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
                      }}
                      onClick={async () => {
                        await getProductInfo(
                          addData.productId as number,
                          addData.productName,
                          0,
                          "",
                        );
                      }}
                    >
                      <Box >
                        エントリー
                      </Box>
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        !isSmartPhone
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: "10px",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      data-testid="contract-add-entry-method-outside"
                      onClick={async () => {
                        if (addData.site_path_list.length === 1) {
                          await getProductInfo(
                            addData.productId as number,
                            addData.productName,
                            1,
                            addData.site_path_list[0],
                          );
                        } else {
                          setAddData((addData) => ({
                            ...addData,
                            addStatus: "site_path",
                          }));
                        }
                      }}
                    >
                      <Box >
                        外部URL作成
                      </Box>
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Typography>
        ) : addData.addStatus === "site_path" ? (
          <Typography
            key="ContractAddModalBoxContract_site_path"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: !isSmartPhone ? undefined : "calc(92vh - 30px)",
              overflowY: !isSmartPhone ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                key="contract1_site_path"
                sx={{}}
              >
                <Box
                  key="shozaiClick_site_path"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                >
                  {addData.site_path_list.map((site_path, i) => {
                    return (
                      <Box
                        sx={{
                          marginTop: "10px",
                          height: "40px",
                          width:
                            !isSmartPhone
                              ? "calc(50% - 5px)"
                              : "calc(100% - 10px)",
                          marginLeft:
                            !isSmartPhone && i % 2 !== 0 ? "10px" : "0",
                        }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            height: "40px",
                            width: "100%",
                            textTransform: "none",
                          }}
                          onClick={async () => {
                            await getProductInfo(
                              addData.productId as number,
                              addData.productName,
                              1,
                              site_path,
                            );
                          }}
                        >
                          <Box >
                            {site_path}
                          </Box>
                        </Button>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Paper>
          </Typography>
        ) : addData.addStatus === "contract" ? (
          <Typography
            key="ContractAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: !isSmartPhone ? undefined : "calc(92vh - 30px)",
              overflowY: !isSmartPhone ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                key="contract1"
                sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
              >
                <Box data-testid="contract-add-selected-product-row" sx={{ display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)" }}>
                  <Box component="span" data-testid="contract-add-selected-product-label" sx={{ fontSize: "var(--fs-11, 11px)", color: "var(--color-sumi-muted, #6b7280)" }}>商材</Box>
                  <Box data-testid="contract-add-selected-product" className="sel-prod-chip" sx={{ display: "inline-flex", alignItems: "center", gap: "var(--sp-2, 8px)", fontSize: "var(--fs-12, 12px)", color: "var(--color-ai, #1e3a5f)", bgcolor: "var(--color-ai-pale, #e8eef4)", borderRadius: "var(--radius-sm, 6px)", padding: "var(--px-3, 3px) var(--px-10, 10px)", fontWeight: "var(--fw-semibold, 600)" }}>
                    {addData.productName as string}
                  </Box>
                </Box>
                {addData.outSiteEntry === 0 ? (
                  <>
                    <PoField fieldKey="servicePlanName">
                      <PoLabel required>プラン</PoLabel>
                      <PoSelect
                        key={"servicePlanSelect"}
                        value={addData.servicePlanName}
                        onChange={(e) => {
                          const servicePlanName = e.target.value as string;
                          setAddData((addData) => ({
                            ...addData,
                            servicePlanName,
                          }));
                        }}
                        fullWidth
                      >
                        {selectServisePlanList.map((service, plan_i) => {
                          return (
                            <MenuItem
                              key={"tableColumnKomokuPlan" + plan_i}
                              value={service.service_name}
                              sx={{
                                fontSize: "14px",
                                height:
                                  service.service_name === ""
                                    ? "14px"
                                    : "24px",
                                minHeight: "auto",
                              }}
                            >
                              {service.service_name}
                            </MenuItem>
                          );
                        })}
                      </PoSelect>
                    </PoField>
                    {selectServiseContentList.length > 0 ? (
                      <PoField key="contractServiceContent" fieldKey="serviceContentNameList">
                        <PoLabel>コンテンツ</PoLabel>
                        <PoCheckGroup>
                          {selectServiseContentList.map((service, si) => (
                            <PoCheckRow key={"serviceContent_" + si}>
                              <PoCheckbox
                                checked={
                                  addData.serviceContentNameList.findIndex(
                                    (serviceName) =>
                                      serviceName === service.service_name,
                                  ) > -1
                                }
                                onClick={() => {
                                  let serviceContentNameList =
                                    addData.serviceContentNameList.concat();
                                  if (
                                    addData.serviceContentNameList.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  ) {
                                    serviceContentNameList =
                                      serviceContentNameList.filter(
                                        (serviceName) =>
                                          serviceName !== service.service_name,
                                      );
                                  } else {
                                    serviceContentNameList.push(
                                      service.service_name,
                                    );
                                  }
                                  setAddData((addData) => ({
                                    ...addData,
                                    serviceContentNameList,
                                  }));
                                }}
                              />
                              {service.service_name}
                            </PoCheckRow>
                          ))}
                        </PoCheckGroup>
                      </PoField>
                    ) : null}
                    {selectServiseCampaignPulldownList.length > 0 ? (
                      <PoField key="serviceeCampaignPulldownLabelBox" fieldKey="serviceCampaignPulldownName">
                        <PoLabel>
                          {selectServiseCampaignCheckboxList.length > 0
                            ? "キャンペーン1"
                            : "キャンペーン"}
                        </PoLabel>
                        <PoSelect
                          key={"serviceCampaignPulldownSelect"}
                          value={addData.serviceCampaignPulldownName}
                          onChange={(e) => {
                            const serviceCampaignPulldownName = e.target
                              .value as string;
                            setAddData((addData) => ({
                              ...addData,
                              serviceCampaignPulldownName,
                            }));
                          }}
                          fullWidth
                        >
                          {selectServiseCampaignPulldownList.map(
                            (service, plan_i) => {
                              return (
                                <MenuItem
                                  key={
                                    "tableColumnKomokuCampaignPulldown" +
                                    plan_i
                                  }
                                  value={service.service_name}
                                  sx={{
                                    fontSize: "14px",
                                    height:
                                      service.service_name === ""
                                        ? "14px"
                                        : "24px",
                                    minHeight: "auto",
                                  }}
                                >
                                  {service.service_name}
                                </MenuItem>
                              );
                            },
                          )}
                        </PoSelect>
                      </PoField>
                    ) : null}
                    {selectServiseCampaignCheckboxList.length > 0 ? (
                      <PoField key="contractServiceCampaignCheckbox" fieldKey="serviceCampaignCheckboxName">
                        <PoLabel>
                          {selectServiseCampaignPulldownList.length > 0
                            ? "キャンペーン2"
                            : "キャンペーン"}
                        </PoLabel>
                        <PoCheckGroup>
                          {selectServiseCampaignCheckboxList.map((service, si) => (
                            <PoCheckRow key={"serviceCampaignCbx_" + si}>
                              <PoCheckbox
                                checked={
                                  addData.serviceCampaignCheckboxName.findIndex(
                                    (serviceName) =>
                                      serviceName === service.service_name,
                                  ) > -1
                                }
                                onClick={() => {
                                  let serviceCampaignCheckboxName =
                                    addData.serviceCampaignCheckboxName.concat();
                                  if (
                                    addData.serviceCampaignCheckboxName.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  ) {
                                    serviceCampaignCheckboxName =
                                      serviceCampaignCheckboxName.filter(
                                        (serviceName) =>
                                          serviceName !== service.service_name,
                                      );
                                  } else {
                                    serviceCampaignCheckboxName.push(
                                      service.service_name,
                                    );
                                  }
                                  setAddData((addData) => ({
                                    ...addData,
                                    serviceCampaignCheckboxName,
                                  }));
                                }}
                              />
                              {service.service_name}
                            </PoCheckRow>
                          ))}
                        </PoCheckGroup>
                      </PoField>
                    ) : null}
                    <PoField fieldKey="servicePaymentMethodName">
                      {selectServisePaymentList.length > 0 ? (
                        <PoLabel required>支払方法</PoLabel>
                      ) : (
                        <PoLabel optional>支払方法</PoLabel>
                      )}
                      {selectServisePaymentList.length > 0 ? (
                        <PoSelect
                          key={"servicePaymentSelect"}
                          value={addData.servicePaymentMethodName}
                          onChange={(e) => {
                            const servicePaymentMethodName = e.target
                              .value as string;
                            setAddData((addData) => ({
                              ...addData,
                              servicePaymentMethodName,
                            }));
                          }}
                          fullWidth
                        >
                          {selectServisePaymentList.map((payment, plan_i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + plan_i}
                                value={payment.payment_method}
                                sx={{
                                  fontSize: "14px",
                                  height:
                                    payment.payment_method === ""
                                      ? "14px"
                                      : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {payment.payment_method}
                              </MenuItem>
                            );
                          })}
                        </PoSelect>
                      ) : (
                        <PoTextField
                          id="textFieldIdPaymentMethod"
                          fullWidth
                          value={addData.servicePaymentMethodName}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              servicePaymentMethodName: e.target.value,
                            }));
                          }}
                        />
                      )}
                    </PoField>
                  </>
                ) : addData.outSiteEntry === 1 ? (
                  <>
                    <PoField key="outsideMessageType" fieldKey="outsideMessageType">
                      <PoLabel required>外部URL共有方法</PoLabel>
                      <PoSelect
                        key={"outsideMessageTypeID"}
                        value={addData.outsideMessageType}
                        onChange={(e) => {
                          const outsideMessageType = e.target
                            .value as number;
                          setAddData((addData) => ({
                            ...addData,
                            smsMessagePatternID: null,
                            outsideMessageType,
                          }));
                        }}
                        fullWidth
                      >
                        {smsMessagePatterns.length > 0 ? (
                          <MenuItem
                            key={"outsideMessageTypeID_1"}
                            value={0}
                            sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                          >
                            SMS送信
                          </MenuItem>
                        ) : null}
                        {mailMessagePatterns.length > 0 ? (
                          <MenuItem
                            key={"outsideMessageTypeID_2"}
                            value={1}
                            sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                          >
                            メール送信
                          </MenuItem>
                        ) : null}
                        <MenuItem
                          key={"outsideMessageTypeID_3"}
                          value={2}
                          sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                        >
                          QRコード表示
                        </MenuItem>
                      </PoSelect>
                    </PoField>
                    {addData.outsideMessageType === 0 ? (
                      <>
                        <PoField key="smsMessagePatternsBox" fieldKey="smsMessagePatternID">
                          <PoLabel required>SMSメッセージ選択</PoLabel>
                          <PoSelect
                            key={"smsMessagePatternID"}
                            value={addData.smsMessagePatternID}
                            onChange={(e) => {
                              const smsMessagePatternID = e.target
                                .value as number;
                              setAddData((addData) => ({
                                ...addData,
                                smsMessagePatternID,
                              }));
                            }}
                            fullWidth
                          >
                            {smsMessagePatterns.map((message, message_i) => (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + message_i}
                                value={message.id}
                                sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                              >
                                {message.outside_sms_name}
                              </MenuItem>
                            ))}
                          </PoSelect>
                        </PoField>
                        {smsMessagePatterns.map((message) => {
                          if (message.id === addData.smsMessagePatternID) {
                            return (
                              <Box key="smsMessageSampleBox">
                                <PoField fieldKey="sms_sender">
                                  <PoLabel>SMSメッセージ-送信ID</PoLabel>
                                  <PoTextField
                                    disabled
                                    fullWidth
                                    value={message.outside_sms_sender}
                                  />
                                </PoField>
                                <PoField fieldKey="sms_body">
                                  <PoLabel>SMSメッセージ-サンプル</PoLabel>
                                  <PoTextField
                                    disabled
                                    fullWidth
                                    value={message.outside_sms_body}
                                    multiline
                                    rows={5}
                                  />
                                </PoField>
                              </Box>
                            );
                          }
                        })}
                      </>
                    ) : addData.outsideMessageType === 1 ? (
                      <>
                        <PoField key="mailMessagePatternsBox" fieldKey="mailMessagePatternID">
                          <PoLabel required>メール選択</PoLabel>
                          <PoSelect
                            key={"mailMessagePatternID"}
                            value={addData.smsMessagePatternID}
                            onChange={(e) => {
                              const smsMessagePatternID = e.target
                                .value as number;
                              setAddData((addData) => ({
                                ...addData,
                                smsMessagePatternID,
                              }));
                            }}
                            fullWidth
                          >
                            {mailMessagePatterns.map((message, message_i) => (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + message_i}
                                value={message.id}
                                sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                              >
                                {message.outside_sms_name}
                              </MenuItem>
                            ))}
                          </PoSelect>
                        </PoField>
                        {mailMessagePatterns.map((message) => {
                          if (message.id === addData.smsMessagePatternID) {
                            return (
                              <Box key="mailMessageSampleBox">
                                <PoField fieldKey="mail_sender">
                                  <PoLabel>メール-送信メールアドレス</PoLabel>
                                  <PoTextField disabled fullWidth value={message.outside_sms_sender} />
                                </PoField>
                                <PoField fieldKey="mail_title">
                                  <PoLabel>メール-タイトル</PoLabel>
                                  <PoTextField disabled fullWidth value={message.outside_sms_title} />
                                </PoField>
                                <PoField fieldKey="mail_body">
                                  <PoLabel>メール-本文</PoLabel>
                                  <PoTextField disabled fullWidth value={message.outside_sms_body} multiline rows={5} />
                                </PoField>
                              </Box>
                            );
                          }
                        })}
                      </>
                    ) : null}
                    {outSidePullDownServiceNameList.length > 0 ? (
                      <PoField key="pullDowmServiceName" fieldKey="pullDownServiceName">
                        <PoLabel required>サービス（プルダウン）</PoLabel>
                        <PoSelect
                          key={"pullDowmServiceNameID"}
                          value={addData.pullDownServiceName}
                          onChange={(e) => {
                            const pullDownServiceName = e.target
                              .value as string;
                            setAddData((addData) => ({
                              ...addData,
                              pullDownServiceName,
                            }));
                          }}
                          fullWidth
                        >
                          {outSidePullDownServiceNameList.map((service, i) => (
                            <MenuItem
                              key={"pullDowmServiceNameID_" + i}
                              value={service.service_name}
                              sx={{ fontSize: "14px", height: "24px", minHeight: "auto" }}
                            >
                              {service.service_name}
                            </MenuItem>
                          ))}
                        </PoSelect>
                      </PoField>
                    ) : null}
                    {outSideCheckBoxServiceNameList.length > 0 ? (
                      <PoField key="contractServiceCheckbox" fieldKey="checkBoxServiceNames">
                        <PoLabel>サービス（チェックボックス）</PoLabel>
                        <PoCheckGroup>
                          {outSideCheckBoxServiceNameList.map((service, si) => (
                            <PoCheckRow key={"outsideCheckbox_" + si}>
                              <PoCheckbox
                                checked={addData.checkBoxServiceNames
                                  .split(",")
                                  .includes(service.service_name)}
                                onClick={() => {
                                  let checkBoxServiceNamesArray =
                                    addData.checkBoxServiceNames.split(",");
                                  if (
                                    checkBoxServiceNamesArray.includes(
                                      service.service_name,
                                    )
                                  ) {
                                    checkBoxServiceNamesArray =
                                      checkBoxServiceNamesArray.filter(
                                        (_serviceName) =>
                                          _serviceName !== service.service_name,
                                      );
                                  } else {
                                    checkBoxServiceNamesArray.push(
                                      service.service_name,
                                    );
                                  }
                                  const checkBoxServiceNames =
                                    checkBoxServiceNamesArray.join(",");
                                  setAddData((addData) => ({
                                    ...addData,
                                    checkBoxServiceNames,
                                  }));
                                }}
                              />
                              {service.service_name}
                            </PoCheckRow>
                          ))}
                        </PoCheckGroup>
                      </PoField>
                    ) : null}
                  </>
                ) : null}

                <PoField fieldKey="serviseCustomerListID">
                  <PoLabel optional>リストID</PoLabel>
                  <PoTextField
                    id="textFieldIdListID"
                    fullWidth
                    value={addData.serviseCustomerListID}
                    onChange={async (e) => {
                      setAddData((addData) => ({
                        ...addData,
                        serviseCustomerListID: e.target.value,
                      }));
                    }}
                  />
                </PoField>
                {addData.outSiteEntry === 1 &&
                addData.outsideMessageType === 1 &&
                useMailAddressFlg === false ? (
                  <PoField fieldKey="mail_address_for_send">
                    <PoLabel required>メールアドレス（メール送信用）</PoLabel>
                    <InputFreeTextMailAddress
                      addData={addData}
                      setAddData={setAddData}
                      uniqueOption={{
                        option_name: "メールアドレス",
                      }}
                      addressOptionName={addressOptionName}
                    />
                  </PoField>
                ) : null}
                {uniqueOptinList.map((uniqueOption, option_i) => {
                  const option_selects = uniqueOption.option_select as string[];
                  let option_view = false;
                  if (addData.outSiteEntry == 0) {
                    const service_plan_names =
                      uniqueOption.service_plan_names as string[];
                    const service_content_names =
                      uniqueOption.service_content_names as string[];
                    const depend_option_name =
                      uniqueOption.depend_option_name as string;
                    const depend_select_names =
                      uniqueOption.depend_select_names as string[];
                    const depend_option_value =
                      addData.customerInfo[depend_option_name];
                    option_view =
                      (service_plan_names.length === 0 ||
                        service_plan_names.includes(addData.servicePlanName)) &&
                      (service_content_names.length === 0 ||
                        service_content_names.some((item) =>
                          addData.serviceContentNameList.includes(item),
                        )) &&
                      (depend_option_name === "他質問に依存しない" ||
                        (typeof depend_option_value === "string" &&
                          depend_select_names.includes(
                            depend_option_value as string,
                          )) ||
                        (typeof depend_option_value === "object" &&
                          depend_select_names.some((item) =>
                            depend_option_value.includes(item),
                          )));
                  } else if (addData.outSiteEntry == 1) {
                    option_view = true;
                  }
                  if (option_view) {
                    return (
                      <PoField key={"optionBox_" + option_i} fieldKey={uniqueOption.option_name as string}>
                        <PoLabel
                          required={
                            addData.outSiteEntry === 0
                              ? uniqueOption.required_optional === 1
                              : addData.outSiteEntry === 1
                                ? (addData.outsideMessageType === 0 && uniqueOption.tel_flg === 1) ||
                                  (addData.outsideMessageType === 1 && uniqueOption.mail_address_flg === 1)
                                : false
                          }
                          optional={
                            addData.outSiteEntry === 0
                              ? uniqueOption.required_optional !== 1
                              : false
                          }
                          note={
                            addData.outSiteEntry === 1 &&
                            !((addData.outsideMessageType === 0 && uniqueOption.tel_flg === 1) ||
                              (addData.outsideMessageType === 1 && uniqueOption.mail_address_flg === 1)) &&
                            uniqueOption.outside_form_display === 1
                              ? "外部ET非表示"
                              : undefined
                          }
                        >
                          {uniqueOption.option_name}
                        </PoLabel>
                        {uniqueOption.option_type === 0 ? (
                          uniqueOption.tel_flg === 1 ? (
                            <InputFreeTextTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.name_flg === 1 ? (
                            <InputFreeTextName
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.company_name_flg === 1 ? (
                            <InputFreeTextCompanyName
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.zip_code_flg === 1 ? (
                            <InputFreeTextZipCode
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.space_flg === 1 ? (
                            <InputFreeTextSpace
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.mail_address_flg === 1 ? (
                            <InputFreeTextMailAddress
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.form_tel_flg === 1 ? (
                            <InputFreeTextFormTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (uniqueOption.half_width_number_flg || 0) === 1 ? (
                            <InputFreeTextHalfWidthNumber
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (
                            <InputFreeText
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          )
                        ) : uniqueOption.option_type === 1 ? (
                          <>
                            <PoSelect
                              key={"tableColumnKomokuDataSelect" + option_i}
                              fullWidth
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={(e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value as string;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                            >
                              {option_selects.map(
                                (option_select: string, select_i) => {
                                  return (
                                    <MenuItem
                                      key={
                                        "tableColumnKomokuMenuItem" +
                                        option_i +
                                        "_" +
                                        select_i
                                      }
                                      value={option_select}
                                      sx={{
                                        fontSize: "14px",
                                        height:
                                          option_select === ""
                                            ? "14px"
                                            : "24px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      {option_select}
                                    </MenuItem>
                                  );
                                },
                              )}
                            </PoSelect>
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 2 ? (
                          <>
                            <PoCheckGroup>
                              {option_selects.map(
                                (option_select: string, select_i) => {
                                  const customerInfoList = addData.customerInfo[
                                    uniqueOption.option_name as string
                                  ] as string[];
                                  return (
                                    <PoCheckRow
                                      key={
                                        "tableColumnKomokuDataBox" +
                                        option_i +
                                        "_" +
                                        select_i
                                      }
                                    >
                                      <PoCheckbox
                                        checked={
                                          customerInfoList.findIndex(
                                            (_option_select) =>
                                              _option_select === option_select,
                                          ) > -1
                                        }
                                        onClick={() => {
                                          let _customerInfoList =
                                            customerInfoList.concat();
                                          if (
                                            customerInfoList.findIndex(
                                              (_option_select) =>
                                                _option_select === option_select,
                                            ) > -1
                                          ) {
                                            _customerInfoList =
                                              _customerInfoList.filter(
                                                (_option_select) =>
                                                  _option_select !==
                                                  option_select,
                                              );
                                          } else {
                                            _customerInfoList.push(option_select);
                                          }
                                          let customerInfo = addData.customerInfo;
                                          customerInfo[
                                            uniqueOption.option_name as string
                                          ] = _customerInfoList;
                                          setAddData((addData) => ({
                                            ...addData,
                                            customerInfo,
                                          }));
                                        }}
                                      />
                                      {option_select}
                                    </PoCheckRow>
                                  );
                                },
                              )}
                            </PoCheckGroup>
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 3 ? (
                          <>
                            <PoTextField
                              id="textFieldIdDate"
                              fullWidth
                              type="date"
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={async (e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                            />
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 4 ? (
                          <PoFileDrop
                            inputProps={{
                              id: "textFieldPicture",
                              onChange: (
                                event_file: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                if (
                                  event_file.target.files &&
                                  event_file.target.files.length > 0
                                ) {
                                  const file = event_file.target.files[0];
                                  const updatedPostPictures = {
                                    ...postPictures,
                                    [uniqueOption.option_name as string]: file,
                                  };
                                  setPostPicture(updatedPostPictures);
                                }
                              },
                            }}
                            error={postPicturesError[uniqueOption.option_name as string]}
                            onClear={() => {
                              const updated = { ...postPictures };
                              delete updated[uniqueOption.option_name as string];
                              setPostPicture(updated);
                              setPostPicturesError({ ...postPicturesError, [uniqueOption.option_name as string]: "" });
                            }}
                          />
                        ) : null}
                      </PoField>
                    );
                  }
                })}
              </Box>
            </Paper>
          </Typography>
        ) : addData.addStatus === "sms_success" ? (
          <>
            <Typography
              id="modal-modal-description"
              sx={{
                mt: 0,
                mb: 5,
                maxHeight: !isSmartPhone ? undefined : "calc(92vh - 150px)",
                overflowY: !isSmartPhone ? undefined : "auto",
              }}
              key="ClosingTossUpModalBoxProject"
            >
              <Paper elevation={0}>
                <Box
                  key="shozai1"
                  sx={{}}
                >
                  <Box

                    key="sms_success"
                    sx={{ marginTop: "15px", marginBottom: "5px" }}
                  >
                    {addData.outsideMessageType === 0
                      ? "SMSを送信しました。"
                      : addData.outsideMessageType === 1
                        ? "メールを送信しました。"
                        : addData.outsideMessageType === 2
                          ? "QRコードを表示します。"
                          : ""}
                  </Box>
                  <Box
                    
                    key="sms_success"
                    sx={{
                      marginTop: "25px",
                      marginBottom: "5px",
                      textAlign: "center",
                      display: !isSmartPhone ? "flex" : undefined,
                    }}
                  >
                    <Box
                      sx={{
                        textAlign: "center",
                        width:
                          !isSmartPhone
                            ? 200
                            : 180,
                        marginLeft:
                          addData.viewOutsideServiceUrl === 1
                            ? !isSmartPhone
                              ? "calc(50% - 210px - 2.5%)"
                              : "auto"
                            : "auto",
                        marginRight:
                          addData.viewOutsideServiceUrl === 1
                            ? !isSmartPhone
                              ? undefined
                              : "auto"
                            : "auto",
                      }}
                    >
                      <Box>
                        エントリーページ
                        <IconButton
                          sx={{
                            height: "25px",
                            width: "25px",
                            marginBottom: "5px",
                          }}
                          aria-label="detail row"
                          size="medium"
                          onClick={() => {
                            const canvas = document.querySelector("canvas");
                            const link = document.createElement("a");
                            if (canvas) {
                              link.href = canvas.toDataURL("image/png");
                              link.download = "qrcode.png";
                              link.click();
                            }
                          }}
                        >
                          <FileDownloadIcon fontSize="medium" />
                        </IconButton>
                      </Box>
                      <Box>
                        <QRCodeCanvas
                          value={addData.outsideSiteUrl}
                          size={!isSmartPhone ? 200 : 180}
                        />
                      </Box>
                    </Box>
                    {addData.viewOutsideServiceUrl === 1 ? (
                      <Box
                        sx={{
                          textAlign: "center",
                          width:
                            !isSmartPhone
                              ? 200
                              : 180,
                          marginLeft:
                            !isSmartPhone ? "calc(10px + 5%)" : "auto",
                          marginRight: !isSmartPhone ? undefined : "auto",
                          marginTop: !isSmartPhone ? undefined : "25px",
                        }}
                      >
                        <Box>
                          サービスページ
                          <IconButton
                            sx={{
                              height: "25px",
                              width: "25px",
                              marginBottom: "5px",
                            }}
                            aria-label="detail row"
                            size="medium"
                            onClick={() => {
                              const canvas = document.querySelector("canvas");
                              const link = document.createElement("a");
                              if (canvas) {
                                link.href = canvas.toDataURL("image/png");
                                link.download = "qrcode.png";
                                link.click();
                              }
                            }}
                          >
                            <FileDownloadIcon fontSize="medium" />
                          </IconButton>
                        </Box>
                        <Box>
                          <QRCodeCanvas
                            value={addData.outsideServiceUrl}
                            size={!isSmartPhone ? 200 : 180}
                          />
                        </Box>
                      </Box>
                    ) : null}
                  </Box>
                  <Box
                    
                    key="sms_success"
                    sx={{
                      marginTop: "45px",
                      marginBottom: "5px",
                      wordWrap: "break-word",
                      wordBreak: "break-all",
                    }}
                  >
                    エントリーページ: <br />
                    {addData.outsideSiteUrl}
                  </Box>
                  {addData.viewOutsideServiceUrl === 1 ? (
                    <Box
                      
                      key="sms_success"
                      sx={{
                        marginTop: "30px",
                        marginBottom: "5px",
                        wordWrap: "break-word",
                        wordBreak: "break-all",
                      }}
                    >
                      サービスページ: <br />
                      {addData.outsideServiceUrl}
                    </Box>
                  ) : null}
                </Box>
              </Paper>
            </Typography>
          </>
        ) : null}
      </PoModalShell>
      <LeaveGuard
          open={leaveGuardOpen}
          fieldName=""
          title="担当アカウントの変更"
          message="担当アカウントを変更すると、入力内容がリセットされます。"
          onClose={() => {
            setLeaveGuardOpen(false);
            setAddData((prev) => ({ ...prev, addStatus: "change_account" }));
          }}
          onReturn={() => setLeaveGuardOpen(false)}
        />
    </>
  ) : null;
}
